export const actionKey = '@@tierConsumer';
export const tierConsumerReduxKey = '@@tierConsumer';

//# sourceMappingURL=constants.js.map